module.exports = __webpack_public_path__ + "static/media/tachometer-alt.9bd66ca2.svg";